import React, { useState } from 'react';
import ColumnOptionList from './ColumnOptionList';
import IconChevronDown from '../../svg/IconChevronDown';

const columnFilterContainer = {
    cursor: 'pointer',
    marginRight: 30,
    paddingBottom: 5
};
const filterLabel = {
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 500,
    marginRight: 8
};
const filterLine = {
    display: 'flex',
    alignItems: 'center'
};

const columnPannelClosed = {
    ...filterLine,
    color: '#414141',
    fill: '#414141'
};
const columnPannelOpen = {
    ...filterLine,
    color: '#FD9A00',
    fill: '#FD9A00'
};

const ColumnFilter = ({
    columnDefs,
    onColumnFilterChange,
    columnPannelWidth = 200,
    showApplyButton,
    onFilterClose
}) => {
    const [showColumnOptionList, setShowColumnOptionList] = useState(false);

    const handleClick = () => {
        setShowColumnOptionList(!showColumnOptionList);
    };
    const handleCloseButtonClick = () => {
        setShowColumnOptionList(false);
    };
    return (
        <div id='columnFilter' style={columnFilterContainer}>
            <div
                onClick={handleClick}
                style={
                    showColumnOptionList ? columnPannelOpen : columnPannelClosed
                }
            >
                <span style={filterLabel}>Filter</span>
                <IconChevronDown width={18} height={20} />
            </div>
            <ColumnOptionList
                visible={showColumnOptionList}
                columns={columnDefs}
                onClose={handleCloseButtonClick}
                panelWidth={columnPannelWidth}
                onChange={onColumnFilterChange}
                showApplyButton={showApplyButton}
                onFilterClose={onFilterClose}
            />
        </div>
    );
};

export default ColumnFilter;
